/**
 * Formata o nome de um arquivo, aplicando diversas transformações, como:
 * - Decodificação de caracteres URI (ex.: "%C3%A9" para "é").
 * - Remoção de identificadores numéricos no início do nome (ex.: "1740760097509_").
 * - Remoção de hashes no final do nome.
 * - Truncamento do nome caso exceda um comprimento máximo especificado.
 *
 * @param {string} cArquivoNome - O caminho ou nome completo do arquivo a ser formatado.
 * @param {number} [nTamanhoMaximo=0] - O comprimento máximo permitido para o nome do arquivo. Se for 0, nenhum truncamento será aplicado.
 * @returns {string} O nome do arquivo formatado, com as alterações aplicadas.
 */
const arquivoNomeFormatar = (cArquivoNome, nTamanhoMaximo = 0) => {
  if (!cArquivoNome) return ""

  // Extrai o nome do arquivo.
  let cArquivoNomeFormatado = cArquivoNome.split("/").pop()

  // Extrai a extensão.
  const lPossuiExtensao = cArquivoNomeFormatado.includes(".")
  const cExtensao = lPossuiExtensao ? `.${cArquivoNomeFormatado.split(".").pop()}` : ""

  // Remove a extensão temporariamente para processar o nome.
  if (lPossuiExtensao) {
    cArquivoNomeFormatado = cArquivoNomeFormatado.replace(cExtensao, "")
  }

  // Decodifica a URI para lidar com caracteres especiais.
  cArquivoNomeFormatado = decodeURI(cArquivoNomeFormatado)

  // Remove possíveis identificadores numéricos no início (ex: "1740760097509_")
  cArquivoNomeFormatado = cArquivoNomeFormatado.replace(/^\d+_/g, "")

  // Remove o hash no final do nome (que foi adicionado pelo back-end ao salvar no S3).
  cArquivoNomeFormatado = cArquivoNomeFormatado.replace(/-\w{8}$/, "")

  // Trunca o nome se exceder o comprimento máximo permitido.
  if (nTamanhoMaximo && cArquivoNomeFormatado.length > nTamanhoMaximo) {
    cArquivoNomeFormatado = `${cArquivoNomeFormatado.slice(0, nTamanhoMaximo)}....`
  }

  // Reanexa a extensão ao final do nome.
  return `${cArquivoNomeFormatado}${cExtensao}`
}

export default arquivoNomeFormatar
